import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { DriveRoundType } from 'types';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export const roundTypeOptions = [
	{ value: DriveRoundType.ASSIGNMENT, label: 'Assignment' },
	{ value: DriveRoundType.INTERVIEW, label: 'Interview' },
	{ value: DriveRoundType.FINAL_ROUND, label: 'Final Round' },
];

const RoundTypeFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const roundType = JSON.parse(searchParams.get('roundType') || '[]');

	const options = roundTypeOptions;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!roundType?.length}
					placeholder={'Round Type'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: roundType?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (roundType?.includes(option?.value?.toString())) {
											searchParams.set(
												'roundType',
												JSON.stringify(roundType?.filter((type: string) => type !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('roundType', JSON.stringify([...roundType, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{roundType?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Round Type</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Assignment Round"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => roundType?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('roundType', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default RoundTypeFilterInput;
